import { render, staticRenderFns } from "./NewsEchartsRisk.vue?vue&type=template&id=6f7fb03a"
import script from "./NewsEchartsRisk.vue?vue&type=script&lang=js"
export * from "./NewsEchartsRisk.vue?vue&type=script&lang=js"
import style0 from "./NewsEchartsRisk.vue?vue&type=style&index=0&id=6f7fb03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports